import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9e5lkbzo3q: FaireBrandEntity = {
  token: "b_9e5lkbzo3q",
  type: "brand",
  name: "The Darling Effect",
  avatarUrl:
    "https://cdn.faire.com/fastly/47c299e756192f5c300b35ebeae5ffe5ec1e6a5b29d1b8a39fb0671bf7030a78.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/111dc5a1af83b391dd3ab174c8d7e453713062779d242d0bc8b995fd3a5927f6.png",
  logoUrl:
    "https://cdn.faire.com/fastly/47c299e756192f5c300b35ebeae5ffe5ec1e6a5b29d1b8a39fb0671bf7030a78.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/111dc5a1af83b391dd3ab174c8d7e453713062779d242d0bc8b995fd3a5927f6.png",
  location: "Grand Rapids, MI, USA",
  minimumOrderDollars: 685,
  rating: 4.9,
  reviewCount: 237,
  isTopShop: true,
  isInsider: true,
  description:
    "My passion and love for packaging design and the product sourcing process grew more than I could’ve imagined after starting my first company, a jewelry brand. From concept and design through final execution, seeing a product come to life is a process I never would’ve thought to love as much as I do. My husband often refers to me as an “idea machine” and this is when I finally knew I needed to create a space to let these ideas flourish and come to life. \n\nGrowing up in a family of all girls, my mom would often be heard saying “that’s so darling,” so naturally, that’s where I found my inspiration! Regardless of what product is developed next by the Darling Effect, you’ll be sure to find yourself thinking, “Oh my gosh, that’s absolutely darling!”\n\nFrom drab to fab, we take your favorite things to new heights and create beautiful experiences one new launch at a time through The Darling Effect.  ",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:01.625Z",
    importedBy: "entity-db-cli",
  },
};
